import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Box, Button, CssBaseline, Tooltip } from '@mui/material'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import { CellProps } from 'react-table'
import { Page } from '../../components/Page'
import { Table } from '../../components/Table'
import EditIcon from '@mui/icons-material/Create'
import { deleteRoles, getRole } from '../../redux/features/roleSlice'
import { IConfig } from '../../interfaces/roleInterface'
import { AppDispatch } from '@/redux/store'
import { Loader } from '../../components/Loader'
import { ToastContainer } from 'react-toastify'
import BreadcrumbsComponent from '../../components/Breadcrums/Breadcrums'
import generateConfig, { Config } from '../../components/HelmetConfig'
import { Helmet } from 'react-helmet'

const ConfigListing: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>()
  const roleList = useSelector((state: any) => state?.role?.roleGettingState)
  const loader = useSelector((state: any) => state?.loader.loader)
  const [isOpen, setIsOpen] = useState(false)
  const [selectedUserId, setSelectedUserId] = useState('')
  const [pageTitle, setPageTitle] = useState('Config Listing')
  const config: Config = generateConfig(pageTitle)

  const data = roleList || []
  const navigate = useNavigate()
  const addRole = useCallback(
    (id: string) => () => {
      navigate(`/configs/${id}`)
    },
    [navigate]
  )

  const editRole = (name: string, id: string) => {
    navigate(`/configs/${name}`, { state: { id } })
  }

  useEffect(() => {
    dispatch(getRole())
  }, [dispatch])

  const handleDeleteRoles = (id: string) => {
    dispatch(deleteRoles(id))
  }

  const handleToggleModal = (userId: string) => {
    setSelectedUserId((prevUserId) => (prevUserId === userId ? '' : userId))
    setIsOpen((prevOpen) => !prevOpen)
  }

  const modalRef = useRef<HTMLDivElement>(null)

  const handleCloseModal = (event: MouseEvent) => {
    if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
      setIsOpen(false)
      setSelectedUserId('')
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleCloseModal)
    return () => {
      document.removeEventListener('mousedown', handleCloseModal)
    }
  }, [])

  const columns = [
    {
      accessor: 'id',
      aggregate: 'id',
      Aggregated: ({ cell: { value } }: CellProps<IConfig>) => `${value}`,
      Header: 'ID'.toUpperCase(),
    },
    {
      Header: 'Config Namespace',
      accessor: 'namespace',
      aggregate: 'namespace',
      Aggregated: ({ cell: { value } }: CellProps<IConfig>) => `${value}`,
    },
    {
      Header: 'Config Key',
      accessor: 'key',
      aggregate: 'key',
      Aggregated: ({ cell: { value } }: CellProps<IConfig>) => `${value}`,
      Cell: (row: any) => (
        <span
          style={{
            textDecoration: 'underline',
            color: '#1976d2',
            cursor: 'pointer',
          }}
          onClick={() => navigate(`/configs/${row.row.original.id}`)} // Add your onClick method here
        >
          {`${row.row.original.key}`}
        </span>
      ),
    },
    {
      Header: 'Description',
      accessor: 'description',
      aggregate: 'description',
      Aggregated: ({ value }: { value: any }) =>
        value !== null ? value : 'N/A',
      Cell: ({ value }: { value: any }) => (value !== null ? value : 'N/A'),
    },
    {
      id: 'action',
      disableSortBy: true,
      disableFilters: true,
      Cell: ({ row }: CellProps<IConfig>) => (
        <Box sx={{ position: 'relative' }}>
          <Tooltip title='Action'>
            <MoreHorizIcon
              onClick={() => handleToggleModal(row.original.id)}
              style={{ cursor: 'pointer' }}
            />
          </Tooltip>
          {isOpen && selectedUserId === row.original.id && (
            <Box
              ref={modalRef}
              sx={{
                position: 'absolute',
                top: 0,
                left: '100%',
                transform: 'translateX(8px)',
                width: 200,
                // height: 80,
                bgcolor: 'background.paper',
                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                p: 1,
                borderRadius: 4,
                zIndex: 1,
              }}
            >
              <Button
                variant='text'
                startIcon={<EditIcon />}
                onClick={() => editRole('edit', row.original.id)}
                sx={{ mb: 1 }}
              >
                Edit
              </Button>
              {/* <Button
                variant="text"
                startIcon={<DeleteIcon />}
                onClick={() => handleDeleteRoles(row.original.id)}
                sx={{ mb: 1 }}
              >
                Delete
              </Button> */}
            </Box>
          )}
        </Box>
      ),
    },
  ]

  return (
    <>
      <BreadcrumbsComponent />
      <Loader loading={loader} />
      <ToastContainer />
      <Helmet>
        <title>{config.title}</title>
      </Helmet>
      <Page>
        <CssBaseline />
        <Table
          name='testTable'
          heading={'Product Configs'}
          columns={columns}
          data={data}
          // onAdd={() => addRole('add')}
          // btnName='Add Product Config'
        />
      </Page>
    </>
  )
}

export default ConfigListing
